// extracted by mini-css-extract-plugin
module.exports =  {"searchOverlay":"header__m1mOisB_TpiHz5e3pV5W"};